import { createContext, useCallback, useContext, useRef, useState } from "react";
import apiConfig from "../utils/allApi";
import apiCall from "../utils/apiCall";

const clientDataContext = createContext();

const sortClients = (data) =>
  [...data].sort((a, b) =>
    (a.clientName || "").trim().localeCompare((b.clientName || "").trim()),
  );

const ClientContext = ({ children }) => {
  const [clients, setClients] = useState([]);
  const [clientsLoading, setClientsLoading] = useState(false);
  const hasFetchedRef = useRef(false);
  const fetchInFlightRef = useRef(false);

  const fetchClients = useCallback(async () => {
    if (fetchInFlightRef.current) return;
    fetchInFlightRef.current = true;
    setClientsLoading(true);
    try {
      const res = await apiCall.get(apiConfig.api_getClients);
      if (res.data?.status === "Success") {
        setClients(sortClients(res.data.data || []));
      } else {
        setClients([]);
      }
    } catch (error) {
    } finally {
      setClientsLoading(false);
      fetchInFlightRef.current = false;
      hasFetchedRef.current = true;
    }
  }, []);

  const ensureClientsLoaded = useCallback(() => {
    if (!hasFetchedRef.current) {
      fetchClients();
    }
  }, [fetchClients]);

  const refetchClients = useCallback(() => fetchClients(), [fetchClients]);

  return (
    <clientDataContext.Provider
      value={{ clients, clientsLoading, ensureClientsLoaded, refetchClients }}
    >
      {children}
    </clientDataContext.Provider>
  );
};

export const useClients = () => useContext(clientDataContext);
export default ClientContext;
